<template>
  <v-select
    v-bind="$attrs"
    append-to-body
    :calculate-position="withPopper"
  >
    <!-- Pass through all slots -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData || {}" />
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select';
import { useVSelectPopper } from '@/Composables/useVSelectPopper';

export default {
  name: 'VSelectWithPopper',
  components: {
    'v-select': vSelect
  },
  inheritAttrs: false,
  setup() {
    const { withPopper } = useVSelectPopper();
    return { withPopper };
  }
};
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
  border-radius: 0 0 6px 6px !important;
  border-top-color: transparent;
  border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
  border-radius: 6px 6px 0 0 !important;
  border-top-style: solid;
  border-bottom-style: none;
  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15) !important;
}
</style>